import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import type { PremiacaoRelatorioColaboradorLinha } from '../tipos/premiacao'

function fmtBrl(v: number): string {
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

function fmtNum(v: number): string {
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function fmtPctTime(v: number): string {
  return `${(v * 100).toFixed(2)}%`
}

/**
 * Gera PDF do relatório por colaborador (mesmas colunas do modal).
 */
export function exportarRelatorioColaboradoresPdf(
  linhas: PremiacaoRelatorioColaboradorLinha[],
  nomeArquivo: string,
  titulo: string,
): void {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })
  doc.setFontSize(12)
  doc.text(titulo, 14, 12)

  const head = [
    [
      'Time',
      'Colaborador',
      'Contratação',
      'Hrs trab.',
      'Vl. hora',
      'Teto',
      '% Alcançado',
      'Prem. Total',
      'Prem. final',
      '% teto',
    ],
  ]

  const body = linhas.map((r) => [
    r.nomeTime,
    r.nomeColaborador,
    r.tipoContratacao,
    fmtNum(r.horasTrabalhadasPessoa),
    fmtBrl(r.valorHora),
    fmtBrl(r.teto),
    fmtPctTime(r.percentualAlcancadoTime),
    fmtBrl(r.premiacaoTotalTime),
    fmtBrl(r.premiacaoFinal),
    r.percentualDoTeto != null ? `${(r.percentualDoTeto * 100).toFixed(1)}%` : '—',
  ])

  let somaHoras = 0
  let somaPremCalc = 0
  let somaPremFinal = 0
  for (const r of linhas) {
    somaHoras += r.horasTrabalhadasPessoa
    somaPremCalc += r.premiacaoCalculada
    somaPremFinal += r.premiacaoFinal
  }

  body.push([
    'Totais',
    '',
    '',
    fmtNum(somaHoras),
    '',
    '',
    '',
    fmtBrl(somaPremCalc),
    fmtBrl(somaPremFinal),
    '',
  ])

  autoTable(doc, {
    head,
    body,
    startY: 16,
    styles: { fontSize: 7 },
    headStyles: { fillColor: [70, 79, 229] },
    theme: 'grid',
    didParseCell: (data) => {
      if (data.section !== 'body')
        return
      const idx = data.row.index
      if (idx === linhas.length) {
        data.cell.styles.fillColor = [229, 231, 235]
        data.cell.styles.fontStyle = 'bold'
        return
      }
      const row = linhas[idx]
      if (row && row.atigiuTeto && row.teto > 0) {
        data.cell.styles.fillColor = [220, 252, 231]
        return
      }
      if (idx % 2 === 0)
        data.cell.styles.fillColor = [249, 250, 251]
    },
  })

  doc.save(nomeArquivo)
}
